const emojiToISO: Record<string, string> = {
  '🇨🇳': 'CN',
  '🇺🇸': 'US',
  '🇯🇵': 'JP',
  '🇰🇷': 'KR',
  '🇬🇧': 'GB',
  '🇫🇷': 'FR',
  '🇩🇪': 'DE',
  '🇷🇺': 'RU',
  '🇮🇳': 'IN',
  '🇨🇦': 'CA',
  '🇦🇺': 'AU',
  '🇧🇷': 'BR',
  '🇸🇬': 'SG',
  '🇹🇼': 'TW',
  '🇭🇰': 'HK',
  '🇹🇭': 'TH',
  '🇲🇾': 'MY',
  '🇮🇩': 'ID',
  '🇵🇭': 'PH',
  '🇻🇳': 'VN',
  '🇲🇴': 'MO',
  // 可继续补充
};
export default emojiToISO;
